import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { Observable, of } from 'rxjs';
import { ResourceMode } from '../enums/resource-mode.enum';

import { TabPermission } from '../interfaces';
import { Rule } from '../proto/consulate/accounts/interfaces/rule.interface';
import { PermissionService } from '../services/permission.service';

@Injectable()
export class TabDistributorResolver implements Resolve<any> {
  constructor(
    private router: Router,
    private permissionService: PermissionService,
    @Inject(null) private tabPermissions: TabPermission[],
    @Inject(null) public parentPath: string
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    if (state.url === this.parentPath) {
      // check each tab permission for access granted
      this.tabPermissions.every((tabPermission: TabPermission) => {
        const rule: Rule = { res: tabPermission.id, mode: ResourceMode.VIEW };

        if (this.permissionService.grantAccess(rule)) {
          this.router.navigateByUrl(tabPermission.absolutePath);
          return false;
        }

        return true;
      });
    }

    return of(null);
  }
}
